import React from "react";

// Config
import { capturePages } from "../../config/values";

// Components
import CaptureSteps from "../../components/CaptureSteps";
import SectionWrapper from "../../components/SectionWrapper";

const AddPhysicalDamagePage = () => {
  return (
    <SectionWrapper>
      <CaptureSteps page={capturePages.PHYSICAL_DAMAGE} />
    </SectionWrapper>
  );
};

export default AddPhysicalDamagePage;
